import { IconBase, IconButton, Logo } from 'bimui';
import './index.less';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as UserSvg } from 'bimui/dist/c1/icons/user-2.svg';
import { ReactComponent as DocumentSvg } from 'bimui/dist/c1/icons/document.svg';
import { useEffect, useState } from 'react';
import localStore, { USER_NAME } from '@/store/local-store';


export default function SystemLibHeader() {

    const navigate = useNavigate();

    const [userName, setUserName] = useState<string>('');

    useEffect(() => {
        setUserName(localStore.get(USER_NAME) || '');
    })

    return (
        <div className="system-lib-header">
            <Logo wrapClassName='top-logo' onClick={() => { navigate(`/desktop`) }} />
            <IconButton icon={<UserSvg />} wrapClassName='file-list-btn' small />
            <IconButton icon={<DocumentSvg />} wrapClassName='file-list-btn' small style={{ marginLeft: 4 }} />
            <span className='fill-remaining-space'></span>
            <div className='user-panel'>
                <IconBase className='avatar-image' />
                <span className='font-12_16-regular'>{userName}</span>
            </div>
        </div>
    )
}